import { Component } from '@angular/core';
import { PartyMenuComponent } from "./PartyMenuComponent";
@Component({
    selector: 'app-party-submenu',
    templateUrl: './PartySubmenuComponent.html',
    standalone: false
})
export class PartySubmenuComponent extends PartyMenuComponent {
}
